export default "__VITE_ASSET__CyWBoC3k__"